import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getVisibleTimeByFormat } from '@elliemae/ds-utilities/timeUtils';
import memoize from 'memoize-one';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import TimeInputs from './TimeInputs.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'moment';
import '../utils-0a7eb302.js';
import '@elliemae/ds-utilities/utils';

var blockName = 'input-time';
var InputTimeContainer = aggregatedClasses('div')(blockName);

var TimeInputImpl = function TimeInputImpl(_ref) {
  var format = _ref.format,
      innerRef = _ref.innerRef,
      onChange = _ref.onChange,
      className = _ref.className,
      value = _ref.value,
      disabled = _ref.disabled,
      clearable = _ref.clearable,
      ariaLabel = _ref['arial-label'];
  var getVisibleTimeInputs = memoize(function (formatValue) {
    return getVisibleTimeByFormat(formatValue);
  });
  var inputsContainer = useRef();

  var handleFocus = function handleFocus(e) {
    if (!e.target.type) {
      inputsContainer.querySelector('input').focus();
    }
  };

  var visibleInputs = useMemo(function () {
    return getVisibleTimeInputs(format);
  });
  return /*#__PURE__*/React.createElement(InputTimeContainer, {
    className: className,
    disabled: disabled,
    innerRef: innerRef,
    onClick: handleFocus
  }, /*#__PURE__*/React.createElement(TimeInputs, _extends({
    "aria-label": ariaLabel,
    clearable: clearable,
    disabled: disabled,
    format: format,
    innerRef: function innerRef(node) {
      inputsContainer = node;
    },
    onChange: onChange,
    time: value
  }, visibleInputs)));
};

TimeInputImpl.propTypes = {
  containerProps: PropTypes.shape({}),

  /**
   * Inner reference to the input
   */
  innerRef: PropTypes.any,

  /**
   * Classes to add to the container
   */
  className: PropTypes.string,

  /**
   * Styles to add to the container
   */
  style: PropTypes.shape({}),

  /**
   * Allows a function that is triggered once the time input changes
   */
  onChange: PropTypes.func,

  /**
   * Valid time format
   */
  format: PropTypes.string,

  /**
   * Default value once the component is initialized
   */
  value: PropTypes.string,

  /**
   * Whether the time input is clearable or not
   */
  clearable: PropTypes.bool,

  /**
   * Whether the time input is disabled or not
   */
  disabled: PropTypes.bool,

  /**
   * Aria label to add to the container
   */
  'aria-label': PropTypes.bool,
  'arial-label': PropTypes.bool
};

export default TimeInputImpl;
//# sourceMappingURL=TimeInputImpl.js.map
